/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Item ligero de lista de ofertas [P_E_01] [P_E_02] [P_E_03]
 * @export
 * @interface CompanyOfferItemWithCompany
 */
export interface CompanyOfferItemWithCompany {
    /**
     * 
     * @type {number}
     * @memberof CompanyOfferItemWithCompany
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyOfferItemWithCompany
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOfferItemWithCompany
     */
    company?: string;
    /**
     * normal, fct, dual
     * @type {string}
     * @memberof CompanyOfferItemWithCompany
     */
    modality?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOfferItemWithCompany
     */
    date?: string;
    /**
     * 
     * @type {object}
     * @memberof CompanyOfferItemWithCompany
     */
    city?: object;
    /**
     * Id Provincia
     * @type {number}
     * @memberof CompanyOfferItemWithCompany
     */
    state?: number;
    /**
     * Offer status
     * @type {number}
     * @memberof CompanyOfferItemWithCompany
     */
    status?: number;
    /**
     * on_site, semi, remote
     * @type {string}
     * @memberof CompanyOfferItemWithCompany
     */
    presence?: string;
    /**
     * Indica si el proceso es remoto
     * @type {boolean}
     * @memberof CompanyOfferItemWithCompany
     */
    isRemoteProcess?: boolean;
    /**
     * lista de ids
     * @type {Array<number>}
     * @memberof CompanyOfferItemWithCompany
     */
    academicPrograms?: Array<number>;
    /**
     * count applications group by status
     * @type {Array<object>}
     * @memberof CompanyOfferItemWithCompany
     */
    counts?: Array<object>;
    /**
     * Indica si la oferta tiene preguntas para incribirse
     * @type {boolean}
     * @memberof CompanyOfferItemWithCompany
     */
    hasQuestions?: boolean;
}

export function CompanyOfferItemWithCompanyFromJSON(json: any): CompanyOfferItemWithCompany {
    return CompanyOfferItemWithCompanyFromJSONTyped(json, false);
}

export function CompanyOfferItemWithCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOfferItemWithCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'modality': !exists(json, 'modality') ? undefined : json['modality'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'presence': !exists(json, 'presence') ? undefined : json['presence'],
        'isRemoteProcess': !exists(json, 'is_remote_process') ? undefined : json['is_remote_process'],
        'academicPrograms': !exists(json, 'academic_programs') ? undefined : json['academic_programs'],
        'counts': !exists(json, 'counts') ? undefined : json['counts'],
        'hasQuestions': !exists(json, 'has_questions') ? undefined : json['has_questions'],
    };
}

export function CompanyOfferItemWithCompanyToJSON(value?: CompanyOfferItemWithCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'company': value.company,
        'modality': value.modality,
        'date': value.date,
        'city': value.city,
        'state': value.state,
        'status': value.status,
        'presence': value.presence,
        'is_remote_process': value.isRemoteProcess,
        'academic_programs': value.academicPrograms,
        'counts': value.counts,
        'has_questions': value.hasQuestions,
    };
}


